import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PaginatedHistory, RollsRoundHistory } from './types';

export interface HistoryState {
  items: RollsRoundHistory[];
  page: number;
  hasMore: boolean;
  loading: boolean;
  fetchedAt: number | null;
}

const initialState: HistoryState = {
  items: [],
  page: 0,
  hasMore: true,
  loading: true,
  fetchedAt: null,
};

const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    setHistory(state, action: PayloadAction<PaginatedHistory>) {
      state.items = action.payload.items;
      state.page = action.payload.page;
      state.hasMore = action.payload.hasMore;
      state.loading = false;
      state.fetchedAt = Date.now();
    },

    appendHistory(state, action: PayloadAction<PaginatedHistory>) {
      state.items = [...state.items, ...action.payload.items];
      state.page = action.payload.page;
      state.hasMore = action.payload.hasMore;
      state.loading = false;
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    // Saga triggers — no reducer logic
    fetchRequest() {},
    fetchIfStale() {},
    fetchNextPage() {},
  },
});

export const historyActions = historySlice.actions;
export const historyReducer = historySlice.reducer;
